// extracted by mini-css-extract-plugin
export default {"animateFlicker":"FlickerText_animateFlicker__V9D3E","flickerAnimation":"FlickerText_flickerAnimation__c0LlS"};